import PropTypes from 'prop-types';
import React from 'react';
import LabelSection from 'components/sections/LabelSection';
import moment from 'moment';
import styles from './AdjustmentDetail.css';

class ItemDetails extends React.Component {
  render() {
    return (
      this._shouldRender() && (
        <div>
          <LabelSection title={this._labelTitle()} />
          <div className="row mb-5px">
            <div className="col-sm-2">
              <span>Date</span>
            </div>
            <div className="col-sm-10">
              <div className="text-right">
                <span>{this._date()}</span>
              </div>
            </div>
            <div className="col-sm-12">
              <div className={styles['separator-row']} />
            </div>
          </div>
          {this.props.renderOutlet && (
            <div className="row mb-5px">
              <div className="col-sm-2">
                <span>Outlet</span>
              </div>
              <div className="col-sm-10">
                <div className={`text-right ${styles['break-word']}`}>
                  {this._outletName()}
                </div>
              </div>
              <div className="col-sm-12">
                <div className={styles['separator-row']} />
              </div>
            </div>
          )}
          <div className="row mb-5px">
            <div className="col-sm-2">
              <span>Note</span>
            </div>
            <div className="col-sm-10">
              <div className="text-right">{this._note()}</div>
            </div>
            <div className="col-sm-12">
              <div className={styles['separator-row']} />
            </div>
          </div>
        </div>
      )
    );
  }

  _labelTitle = () => {
    const { namespace } = this.props;
    if (namespace === 'items') {
      return 'Item Details';
    }
    return 'Ingredient Details';
  };

  _date = () => {
    const {
      namespace,
      adjustmentDetail,
      ingredientAdjustmentDetail,
    } = this.props;
    const FORMAT = 'D MMMM YYYY HH:mm';
    if (namespace === 'items') {
      return moment(adjustmentDetail.created_at).format(FORMAT);
    }
    return moment(ingredientAdjustmentDetail.created_at).format(FORMAT);
  };

  _outletName = () => {
    const {
      namespace,
      adjustmentDetail,
      ingredientAdjustmentDetail,
    } = this.props;
    if (namespace === 'items') {
      return adjustmentDetail.outlet.name;
    }
    return ingredientAdjustmentDetail.outlet.name;
  };

  _note = () => {
    const {
      namespace,
      adjustmentDetail,
      ingredientAdjustmentDetail,
    } = this.props;
    if (namespace === 'items') {
      return adjustmentDetail.note;
    }
    return ingredientAdjustmentDetail.note;
  };

  _shouldRender = () => {
    const {
      namespace,
      adjustmentDetail,
      ingredientAdjustmentDetail,
    } = this.props;
    if (namespace === 'items') {
      return !!adjustmentDetail;
    }
    return !!ingredientAdjustmentDetail;
  };
}

ItemDetails.propTypes = {
  adjustmentDetail: PropTypes.Object,
  ingredientAdjustmentDetail: PropTypes.Object,
  namespace: PropTypes.string,
  renderOutlet: PropTypes.bool,
};

export default ItemDetails;
